const SectionTitle = ({ title, subtitle, align = 'center' }) => {
  const alignment = align === 'left' ? 'text-left' : 'text-center';

  return (
    <div className={`max-w-3xl mx-auto ${alignment}`}>
      <h2
        className="text-3xl sm:text-4xl lg:text-5xl font-serif font-semibold text-primary dark:text-white mb-4"
        id="section-title"
      >
        {title}
      </h2>
      {subtitle && (
        <p className="text-lg sm:text-xl text-neutral-600 dark:text-neutral-300 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
